import React__default from 'react';
import LeftArrowBlackIcon from '../assets/icons/left-icon-black.icon.js';
import classNames from './../external_lib/classnames/index.js';

function CarouselNavigator(_a) {
    var classes = _a.classes, onPrevClick = _a.onPrevClick, onNextClick = _a.onNextClick;
    return (React__default.createElement("div", { className: classNames('carousel-navigator', classes) },
        React__default.createElement("div", { onClick: function () { return onPrevClick === null || onPrevClick === void 0 ? void 0 : onPrevClick(); }, className: "carousel-navigator__left" },
            React__default.createElement(LeftArrowBlackIcon, null)),
        React__default.createElement("div", { onClick: function () { return onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick(); }, className: "carousel-navigator__right" },
            React__default.createElement(LeftArrowBlackIcon, null))));
}

export { CarouselNavigator as default };
//# sourceMappingURL=CarouselNavigator.js.map
